'use client';

import type { ReactNode } from 'react';
import { SITE } from '@/app/constants';
import { ToastSuccessIcon } from './toast-success-icon';
import { toast } from './use-toast';

/**
 * 创作任务提交成功后统一使用设计稿中的顶部提示，避免影响其他成功 Toast。
 */
export const showTaskSubmitSuccessToast = (message: ReactNode): void => {
  toast({
    type: 'custom',
    message,
    icon: <ToastSuccessIcon />,
    containerClassName:
      'fixed top-[72px] left-1/2 z-[100] -translate-x-1/2 rounded-full bg-[#2E2F33] px-6 py-4 text-sm text-white shadow-none backdrop-blur-[20px]',
    contentClassName:
      SITE === 'china'
        ? "gap-2 font-['PingFang_SC'] font-semibold text-sm text-white leading-5 opacity-100"
        : 'gap-2 font-Poppins font-semibold text-sm text-white leading-5 opacity-100',
  });
};
